import betaSignupsReducer from './beta_signups'
import placesReducer from './places'
import tagsReducer from './tags'
import usersReducer from './users'

export const adminReducer = (
  {
    beta_signups,
    places,
    tags,
    users
  },
  action) => {
  return {
    beta_signups: betaSignupsReducer(beta_signups, action),
    places: placesReducer(places, action),
    tags: tagsReducer(tags, action),
    users: usersReducer(users, action)
  }
}
export default adminReducer
